import { lazy } from "react";
export { CRM_DOCUMENT_PATH } from "./path";
export const CrmDocumentPage = lazy(() => import("./page"));
